module.exports = __webpack_public_path__ + "static/media/help_map.09155050.svg";